import _typeof from "@babel/runtime/helpers/typeof";
// Helper function to extract component name from fiber
export default function getComponentName(fiber) {
  var type = fiber === null || fiber === void 0 ? void 0 : fiber.type;
  if (!type) {
    return undefined;
  }
  if (typeof type === 'function' || _typeof(type) === 'object') {
    return type.displayName || type.name;
  }
  return undefined;
}